import { useContext, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import { API_URL } from '../../../../utils/constants';
import createIcon from '../../../../static/img/createIcon.svg';
import GridWrapper from '~/src/components/common/GridWrapper';
import CategoriesApi from '~/src/services/api/CategoriesApi';
import styled from 'styled-components';
import SecondaryButton from '~/src/components/common/forms/Button/SecondaryButton';
import MyContext from '~/src/services/context';
import { CATEGORY_SOURCE_TYPE, INTEGRATION_TYPE } from '~/src/utils/integrationsConstants';

export default function CategoriesList(): JSX.Element {
  const history = useHistory();
  const stateRef = useRef(null);
  const url = `${API_URL}/products/categories/get`;
  const StatefullGrid = withState(Grid, url);
  const context = useContext(MyContext);


  const [loading, setLoading] = useState(false);

  const handlePullGombaCategories = async () => {
    setLoading(true);
    try {
      await CategoriesApi.pullGombaCategories();
      if (stateRef.current && stateRef.current.reload) {
        stateRef.current.reload();
      }
    } catch (e) {
      setLoading(false);
    }
    setLoading(false);
  };

  const categoryNameCell = (row) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/categories/edit/${dataItem.id}`}>{dataItem?.name}</Link>
      </td>
    );
  };

  const categorySourceTypeCell = (row) => {
    const { dataItem } = row;
    const type = Object.values(CATEGORY_SOURCE_TYPE).find((s) => s.value === dataItem.categorySourceType);

    return (
      <td>
        <Link to={`/categories/edit/${dataItem.id}`}>{type?.label ?? 'Unknown Category Source'}</Link>
      </td>
    );
  };

  return (
    <WhitePad>
      <TitleComponent
        title="Categories"
        titleRight="Create"
        onRightHandler={(): void => history.push('/categories/create')}
        iconRight={createIcon}
        titleLeft="Back"
        onLeftHandler={(): void => history.goBack()}
      />
      <div style={{ marginBottom: 16 }}>
        <ActionsWrapper>{
          context.user?.activeIntegrations?.includes(INTEGRATION_TYPE.GOMBA_SHOP.label) && (
            <SecondaryButton
              onClick={handlePullGombaCategories}
              disabled={loading}
              title={loading ? 'Pulling...' : 'Pull Categories From GombaShop'}
            />
          )}

        </ActionsWrapper>
      </div>
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn field="name" title="Category Name" cell={(row) => categoryNameCell(row, stateRef)} />
          <GridColumn
            field="categorySourceType"
            title="Category Source Type"
            cell={(row) => categorySourceTypeCell(row, stateRef)}
            filterable={false} />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}

const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  width: 100%;
  margin-bottom: 16px;
`;